// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Hkzk","boxTitle":"Qualiphy_boxTitle__28bnX","box":"Qualiphy_box__15jMH","toggleWrap":"Qualiphy_toggleWrap__35YGU"};